import { animate, AnimationTriggerMetadata, keyframes, style, transition, trigger } from "@angular/animations";


export const showSidebarAnimation: AnimationTriggerMetadata =
	trigger('smoothShow', [
		transition( ':enter', [
			animate( '300ms ease', keyframes([
				style( { transform: 'translateX(-100%)', offset: 0 } ),
				style( { transform: 'translateX(0)', offset: 1 } ),
			]))
		]),
		transition( ':leave', [
			animate( '200ms ease', keyframes([
				style( { opacity: '1', offset: 0 } ),
				style( { opacity: '0', transform: 'translateX(-100%)', offset: 1 } )
			]))
		])
	]);
